import Slider from '@mui/material/Slider';
import { css } from '@linaria/core';
import { baseTheme, theming } from 'styles/utils/core';
import { styled } from '@mui/material/styles';
const BAR_SIZE = 8;
const THUMB_SIZE = 18;
export const StyledSlider = styled(Slider, {
  shouldForwardProp: prop => prop !== 'primaryColor' && prop !== 'secondaryColor'
})<{
  primaryColor: string;
  secondaryColor: string;
}>(({
  primaryColor,
  secondaryColor
}) => ({
  '& .MuiSlider-rail': {
    height: BAR_SIZE,
    backgroundColor: secondaryColor,
    opacity: 1
  },
  '& .MuiSlider-track': {
    height: BAR_SIZE,
    backgroundColor: primaryColor,
    border: 0
  },
  '& .MuiSlider-thumb': {
    width: THUMB_SIZE,
    height: THUMB_SIZE,
    backgroundColor: baseTheme.light.colors.white,
    color: '#DFE3EA',
    border: `1px solid currentColor`,
    transition: 'box-shadow 0.3s, color 0.3s',
    pointerEvents: 'auto !important',
    '&, &.Mui-focusVisible': {
      boxShadow: `0 2px 4px -2px ${baseTheme.light.colors.gray900}0F, 0 4px 8px -2px ${baseTheme.light.colors.gray900}1A`
    },
    '&:hover': {
      color: `${baseTheme.light.colors.gray700} !important`,
      boxShadow: 'unset'
    },
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      width: '1px',
      backgroundColor: `${baseTheme.light.colors.gray700}`,
      borderRadius: '5px',
      transform: 'translateY(-50%)'
    },
    '&::before': {
      left: '50%',
      height: '60%',
      transform: 'translateX(-50%) translateY(-50%)',
      boxShadow: 'unset'
    },
    '&::after': {
      left: '50%',
      height: '40%',
      transform: 'translateX(-50%) translateY(-50%)',
      boxShadow: `-4px 0 0 0 ${baseTheme.light.colors.gray700},4px 0 0 0 ${baseTheme.light.colors.gray700}`
    }
  }
}));
export const container = "omponents__Slider__BaseSlider__styles_ts-container-c1i6jpks";
export const slider = "omponents__Slider__BaseSlider__styles_ts-slider-skksx8q";
export const label = "omponents__Slider__BaseSlider__styles_ts-label-lzblg0y";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");